import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";

export default function ImageCropperModal({ imageSrc, onCancel, onCropComplete }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // Called when crop changes (position/zoom)
  const onCropAreaComplete = useCallback((croppedArea, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  // Convert cropped area into blob/file
  const getCroppedImage = async () => {
    if (!croppedAreaPixels) {
      // fallback if user hasn't moved/zoomed
      const img = new Image();
      img.src = imageSrc;
      await new Promise((resolve) => (img.onload = resolve));
      setCroppedAreaPixels({ x: 0, y: 0, width: img.width, height: img.height });
    }

    const image = new Image();
    image.src = imageSrc;
    await new Promise((resolve) => (image.onload = resolve));

    const crop = croppedAreaPixels || { x: 0, y: 0, width: image.width, height: image.height };

    const canvas = document.createElement("canvas");
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x,
      crop.y,
      crop.width,
      crop.height,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          const file = new File([blob], "photograph.jpg", { type: "image/jpeg" });
          resolve(file);
        },
        "image/jpeg",
        1
      );
    });
  };

  const handleCropSave = async () => {
    const croppedFile = await getCroppedImage();
    onCropComplete(croppedFile);
  };

  return (
    <div className="cropper-modal">
      <div className="cropper-container" style={{ position: "relative", width: "100%", height: 400 }}>
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={3 / 4} // Passport photo ratio
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropAreaComplete}
          onMediaLoaded={(mediaSize) => {
            // Initialize cropped area on load
            setCroppedAreaPixels({
              x: 0,
              y: 0,
              width: mediaSize.width,
              height: mediaSize.height,
            });
          }}
        />
      </div>

      <div className="crop-controls" style={{ marginTop: 20 }}>
        <input
          type="range"
          min={1}
          max={3}
          step={0.1}
          value={zoom}
          onChange={(e) => setZoom(Number(e.target.value))}
        />
        <div className="buttons" style={{ marginTop: 10 }}>
          <button className="btn btn-secondary" onClick={onCancel} style={{ marginRight: 10 }}>
            Cancel
          </button>
          <button className="btn btn-success" onClick={handleCropSave}>
            Save Crop
          </button>
        </div>
      </div>
    </div>
  );
}
